import Model from './Model';

export default class Contact extends Model {
  resource() {
    return 'contacts';
  }
}
